import { useState } from 'react';
import AttendTrackApp from './AttendTrackApp';
import DevPanel        from './DevPanel';
import { TokenStore }  from './api';

// ── Dev impersonation banner ──────────────────────────────────────────────────
function DevBanner({ info, onBack }) {
  const expiresAt = info.started_at + info.expires_in * 60_000;
  const minsLeft  = Math.max(0, Math.round((expiresAt - Date.now()) / 60_000));
  return (
    <div style={{
      position: "fixed", top: 0, left: 0, right: 0, zIndex: 9999,
      background: "#3b0764", borderBottom: "2px solid #7c3aed",
      padding: "8px 20px", display: "flex", alignItems: "center",
      justifyContent: "space-between",
      fontFamily: "'DM Mono','Fira Mono',monospace", fontSize: 12,
      color: "#ddd6fe", boxShadow: "0 2px 12px rgba(124,58,237,.4)",
    }}>
      <span>
        ⚠ Developer Session —{" "}
        viewing as HR Admin for{" "}
        <strong style={{ color: "#c4b5fd" }}>
          {info.tenant_name || info.tenant_id}
        </strong>
        {" "}· expires in ~{minsLeft} min
      </span>
      <button
        onClick={onBack}
        style={{
          background: "#6d28d9", color: "#fff", border: "1px solid #7c3aed",
          borderRadius: 5, padding: "5px 16px", fontSize: 12,
          cursor: "pointer", fontWeight: 700, fontFamily: "inherit",
        }}
      >
        ← Back to Dev Panel
      </button>
    </div>
  );
}

// ── Root ──────────────────────────────────────────────────────────────────────
export default function App() {
  const params = new URLSearchParams(window.location.search);

  // Detect active developer impersonation session
  const [impersonating] = useState(() => {
    try {
      const raw = sessionStorage.getItem("at_dev_impersonating");
      if (!raw) return null;
      const info = JSON.parse(raw);
      // Ensure main token still exists and session hasn't expired
      if (!localStorage.getItem("at_token")) {
        sessionStorage.removeItem("at_dev_impersonating");
        return null;
      }
      const expiresAt = info.started_at + info.expires_in * 60_000;
      if (Date.now() > expiresAt) {
        TokenStore.clearSession();
        sessionStorage.removeItem("at_dev_impersonating");
        return null;
      }
      return info;
    } catch { return null; }
  });

  const handleBackToDevPanel = () => {
    TokenStore.clearSession();
    sessionStorage.removeItem("at_dev_impersonating");
    window.location.href = "/?panel=devaccess";
  };

  // Secret developer panel
  if (params.get("panel") === "devaccess") {
    return <DevPanel />;
  }

  // Developer impersonation view
  if (impersonating) {
    return (
      <>
        <DevBanner info={impersonating} onBack={handleBackToDevPanel} />
        <div style={{ paddingTop: 42 }}>
          <AttendTrackApp defaultTab="hr" />
        </div>
      </>
    );
  }

  if (window.location.pathname.startsWith("/hr")) {
    window.history.replaceState({}, "", "/");
    return <AttendTrackApp defaultTab="hr" />;
  }
  return <AttendTrackApp defaultTab="employee" />;
}
